<template>
  <div class="login-container">
    <div class="card">
      <p class="set-password-title">Setup Account</p>
      <div class="form-item">
        <span>New Password</span>
        <v-input
          v-model="password"
          type="password"
          @keyEnter="firstConfirmPassword"/>
      </div>
      <div class="form-item">
        <span>Confirm Password</span>
        <v-input
          v-model="confirm_password"
          type="password"
          @keyEnter="firstConfirmPassword" />
      </div>
      <v-button
        type="success"
        @click="firstConfirmPassword">Next</v-button>
    </div>
  </div>
</template>
<script>
import {firstConfirmPassword} from '@api/index'
import {mapState} from 'vuex'

export default {
  name: 'resetPassword',
  data() {
    return {
      confirm_password: '',
      password: ''
    }
  },
  computed:{
    ...mapState('verify',['isVerify']),
  },
  methods: {
    firstConfirmPassword() {
      this.network().firstConfirmPassword()
    },
    network() {
      return {
        firstConfirmPassword: async () => {
          const { data } = await firstConfirmPassword({
            confirm_password: this.confirm_password,
            password: this.password
          })
          const { fullPath = '' } = this.$route.query
          this.$router.push({
            path: '/reset/verify',
            query: {
              fullPath
            }
          })
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background: #fff;
  .card {
    padding: 100px 0;
    width: 500px;
    box-shadow: none;
    text-align: center;
    .set-password-title{
      font-weight: 600;
      font-size: 24px;
      line-height: 36px;
      letter-spacing: 0.3px;
      color: #24292E;
      text-align: left;
      margin-bottom: 40px;
    }
    .form-item {
      margin: 0 auto;
      width: 500px;
      padding-bottom: 20px;
      & > span {
        text-align: left;
      }
    }
    .el-button{
      width: 100%;
      margin-top: 10px;
      //font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      //display: flex;
      //align-items: center;
      letter-spacing: -0.15px;
      color: #FFFFFF;
      background: #2EA44F;
      border: 1px solid rgba(27, 31, 35, 0.15);
      box-sizing: border-box;
      box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.1);
      border-radius: 6px;
      &--success:hover {
        background: #2EA44F;
        opacity: 0.8;
        border-color: rgba(27, 31, 35, 0.15);
      }
    }
  }
}
</style>
